'use client'
import Link from 'next/link'
import React from 'react'
import { Button } from '../ui/button'
import { useUser } from '~/provider/UserProvider'
import { Skeleton } from '../ui/skeleton'

const ButtonLogin = () => {
    const [user, _, isLoading] = useUser()
    return (
        <>
            {!user && isLoading && <Skeleton className='h-h-6.75 w-23.75 rounded-lg' />}
            {!user && !isLoading && (
                <div className='ml-1 flex items-center'>
                    <Link href={'/login'}>
                        <Button className='rounded-lg h-auto px-3 py-1.5 font-normal text-xs sm:text-sm'>
                            Đăng nhập
                        </Button>
                    </Link>
                </div>
            )}
        </>
    )
}

export default ButtonLogin
